import t from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import m from "./iconfont.es5471.js";
const d = {
  display: "block"
}, x = ({ size: a = 16, useVw: l, useRem: o, color: e, withColor: i, removeClassName: n, disableSSR: g, style: c, ...p }) => {
  const h = c ? { ...d, ...c } : d;
  return /* @__PURE__ */ t.createElement(m, { disableSSR: g }, /* @__PURE__ */ t.createElement("svg", { "data-icon-id": "32px-gangganjiaoyi", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (o ? "rem" : "px"), height: l ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (o ? "rem" : "px"), className: n ? "" : "iconpark-icon", style: h, fill: "none", ...p }, /* @__PURE__ */ t.createElement(
    "g",
    {
      className: n ? "" : "32px-æ æäº¤æ"
    },
    /* @__PURE__ */ t.createElement(
      "path",
      {
        className: n ? "" : "normal",
        d: "M3.605 5.104a.9.9 0 0 1 .99-.799l23 2.456a.9.9 0 1 1-.19 1.79l-2.407-.257v5.326h1.992a.9.9 0 1 1 0 1.8h-5.783a.9.9 0 0 1 0-1.8h1.99V8.102l-6.293-.672v11.944h5.325c.934 0 1.732.676 1.886 1.598l.674 4.047a1.912 1.912 0 0 1-1.886 2.227H9.101a1.912 1.912 0 0 1-1.886-2.227l.354-2.124a.9.9 0 0 1 1.776.296l-.354 2.124a.112.112 0 0 0 .11.13h13.802a.11.11 0 0 0 .11-.13l-.674-4.048a.112.112 0 0 0-.11-.093h-6.227a.9.9 0 0 1-.888-.756h-.01v-.085a.879.879 0 0 1 0-.118V7.238l-6.298-.673v4.742H10.8a.9.9 0 1 1 0 1.8H5.016a.9.9 0 1 1 0-1.8h1.99V6.373l-2.601-.278a.9.9 0 0 1-.8-.99Z",
        fill: i ? r(e, 0, "#262933") : "#262933",
        datafollowfill: i ? r(e, 0, "#262933") : "#262933"
      }
    )
  )));
}, y = x;
export {
  y as default
};
